import { AccountingDocType } from '../../../api/types/accounting/accounting-documents-entity';
import { PaymentMethodsDb } from '../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { CardBrandType } from '../../../api/types/students/credit-card-tokens/credit-card-token-entity';

export interface AccountingDocumentsFilterType {
  accountingType: AccountingDocType | null;
  serialNumber: number | null;
  startSerialNumber: number | null;
  endSerialNumber: number | null;
  startFromDate: Date | null;
  toDate: Date | null;
  paymentMethod: PaymentMethodsDb | null;
  creditCardCompany: CardBrandType[];
  amount: number | null;
  amountFrom: number | null;
  amountTo: number | null;
  paymentServiceIds: number[];
  /** Backend Joi requires this array on every list request (empty = no branch filter). */
  branchIds: number[];
  itemDescriptionSubText: string | null;
  showCrmDocuments: boolean;
  showStudentDocument: boolean;
  creditCardLast4Digit: string | null;
  /** Backend Joi requires this on every list request. */
  includeDocumentWithNoBranch: boolean;
}

export const defaultAccountingDocumentsFilter =
  (): AccountingDocumentsFilterType => ({
    accountingType: null,
    serialNumber: null,
    startSerialNumber: null,
    endSerialNumber: null,
    startFromDate: null,
    toDate: null,
    paymentMethod: null,
    creditCardCompany: [],
    amount: null,
    amountFrom: null,
    amountTo: null,
    paymentServiceIds: [],
    branchIds: [],
    itemDescriptionSubText: null,
    showCrmDocuments: true,
    showStudentDocument: true,
    creditCardLast4Digit: null,
    includeDocumentWithNoBranch: true,
  });
